import { render, staticRenderFns } from "./dashboard-filter-accordion.vue?vue&type=template&id=45d6bef0"
import script from "./dashboard-filter-accordion.vue?vue&type=script&lang=js"
export * from "./dashboard-filter-accordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports